module.exports = __webpack_public_path__ + "img/flag-green.bb643b04.svg";